import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';

import config from '@/config';
import { extensionStoreUrl } from '@/modules/extension/constants';
import { IconButton, Text } from '@/modules/ui';

import { SecretFieldSection } from '../SecretFieldSection';
import * as felaRules from './SecretPasskeyRecord.rules';

export interface SecretPasskeyRecordProps {
    createdAt: string;
    onRemove?: () => void;
}

export const SecretPasskeyRecord = ({ createdAt, onRemove }: SecretPasskeyRecordProps) => {
    const { formatDate } = useIntl();
    const { css } = useFela();

    return (
        <SecretFieldSection
            heading={<FormattedMessage id='secret.passkey.label' />}
            tooltip={{
                title: (
                    <FormattedMessage
                        id='secret.passkey.tooltip'
                        values={{
                            a: chunks => (
                                <a href={extensionStoreUrl ?? config.links.docsPasskeys} target='_blank' rel='noreferrer noopener'>
                                    {chunks}
                                </a>
                            ),
                        }}
                    />
                ),
            }}
        >
            <div className={css(felaRules.container)}>
                <Text color='foregroundsTertiary'>
                    <FormattedMessage id='secret.passkey.createdAt' values={{ date: formatDate(createdAt) }} />
                </Text>

                {onRemove && (
                    <IconButton
                        type='ghost'
                        icon={{
                            type: 'trash',
                            color: 'red',
                        }}
                        onClick={onRemove}
                    />
                )}
            </div>
        </SecretFieldSection>
    );
};
